import React, { useState } from "react"
import styles from "./ChatUi.module.css"
import PreviewImage from "../common/previewImage"
interface imageProps {
  imageUpload: {
    mediaFiles: [] | any
    profilePic: string
  }
  isProvider: string
}
const ChatImage = ({ imageUpload, isProvider }: imageProps) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null)

  const handleImageClick = (image: string) => {
    setSelectedImage(image)
  }

  const handleClose = () => {
    setSelectedImage(null)
  }
  return (
    <div
      className={`d-flex ${
        isProvider ? "justify-content-end" : ""
      } mt-0 gap-0 w-100 ${styles["Chat-image-sec"]}`}
    >
      {imageUpload?.mediaFiles?.map((media: any, index: number) => (
        <img
          className={`${styles["image-upload-sec"]}`}
          key={index}
          onClick={() => handleImageClick(media)}
          src={media}
          style={{
            width: imageUpload.mediaFiles.length === 1 ? "150x" : "120px",
            height: imageUpload.mediaFiles.length === 1 ? "150px" : "120px",
            border:
              imageUpload.mediaFiles.length === 1
                ? "2px solid transparent"
                : "2px solid #fff",
            objectFit: "cover",
            marginTop: "30px",
            cursor: "pointer",
          }}
        />
      ))}
      <PreviewImage
        selectedImage={selectedImage}
        handleClosePreview={handleClose}
      />
    </div>
  )
}

export default ChatImage
